import { render, staticRenderFns } from "./CollegeUserTestReports.vue?vue&type=template&id=2abf1270"
import script from "./CollegeUserTestReports.vue?vue&type=script&lang=js"
export * from "./CollegeUserTestReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports